import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import  './util/i18next';

class WebComponent extends HTMLElement {
  connectedCallback() {
    // ReactDOM.render(<App />, this);
    const root = ReactDOM.createRoot(this);
    root.render(<App />, this);
  }
}
 
const ELEMENT_ID = "dubai-health-chat-app";
 
if (!customElements.get(ELEMENT_ID)) {
  customElements.define(ELEMENT_ID, WebComponent);
}
